import { LoginConsts } from 'client/util/Constants';
import MfaConstants from 'client/containers/Login/MfaConstants';
import MfaType from 'client/containers/Login/MfaType';
import routes from 'client/routes/RouteGenerator';

const { clientType } = LoginConsts;

export default (mfa = { factors: [] }, options = {}) => {
  const mfaFactors = mfa.factors.map((factor) => MfaType(
    {
      factor,
      challenge: mfa.challenge,
    },
    options,
  )).filter((f) => f.status === MfaConstants.mfaStatus.available);

  return {
    name: routes.chooseMfa,
    params: {
      clientType: clientType.user,
      factors: mfaFactors,
      redirectTo: options.redirectTo,
      context: options.context,
    },
  };
};
